import { __assign } from "tslib";
import { isSourceGroupWithOptions } from "../interfaces";
import { runPlugins } from "./plugins";
import { runRender } from "./render";

function serializeSource(source) {
  source.source.data = source.source.data || {};

  if (typeof source.source.rawContent === "string") {
    source.source.rawContent = source.source.rawContent.trim();
  }

  return source;
}

function serializeSourceGroup(group) {
  return __assign(__assign({}, group), {
    sources: group.sources.map(function (s) {
      return serializeSource(s);
    })
  });
}

function serializeSources(sources) {
  return sources.map(function (source) {
    if (isSourceGroupWithOptions(source)) {
      return serializeSourceGroup(source);
    }

    return serializeSource(source);
  });
}

function extractSource(source) {
  return source.source;
}

function extractSourceGroup(group) {
  return group.sources.map(function (s) {
    return extractSource(s);
  });
}

function extractSources(sources) {
  return sources.map(function (source) {
    if (isSourceGroupWithOptions(source)) {
      return extractSourceGroup(source);
    }

    return extractSource(source);
  });
}

function runSystem(options) {
  var preProcessedSources = runPlugins(options.sources, options.plugins);
  preProcessedSources = serializeSources(options.sources);
  preProcessedSources = runRender(options.sources, options.renderEngines);
  return preProcessedSources;
}

export { runSystem, extractSources };